import api from "@/api/index.js";

export function isMobile() {
  return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
}

// 获取指定的URL参数值
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

// 判断是否是微信
export function isWeChat() {
  const ua = window.navigator.userAgent.toLowerCase().toLowerCase();
  if (ua.indexOf("micromessenger") > -1) {
    // 如果是微信
    return true;
  }
  return false;
}
// 判断是否是苹果
export function isIOS() {
  return !!window.navigator.userAgent.toLowerCase().match(/\(i[^;]+;( U;)? cpu.+mac os x|mac/);
}

// 获取渠道参数 根据渠道参数下载不同apk

// let url = "";
// api
//   .appDownloadUrlInfo()
//   .then((res) => {
//     url = res.data;
//   })
//   .catch((res) => {
//     // 失败进行的操作
//     console.warn();
//     ("获取app download url失败");
//   });

// export function downloadUrl() {
//   return url;
// }

// 扫码下载跳转页面(暂时未用到)
export function apkUrl() {
  const id = getQueryString("id");
  if (id) {
    return window.location.origin + "/Download?id=" + id;
  } else {
    return window.location.origin + "/Download";
  }
}

/**
 *  防抖函数。使用柯里化返回新函数
 * @param fn
 * @param delay
 * @returns {Function}
 */
export function debounce(fn, delay) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export function getElementTop(element) {
  let actualTop = element.offsetTop;
  let current = element.offsetParent;

  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
}



//////////////////
// WEBPACK FOOTER
// ./static/js/common.js
// module id = null
// module chunks = 